'use es6';

import { defaultImage, ALIGNMENT_OPTIONS } from 'FormsCommonComponents/constants/RichTextImage';
import { getSelectedFormItemReference } from 'FormsUI/selectors/FormSelection';
import getAlignmentValue from 'forms-utils-lib/utils/RichText/getAlignmentValue';
import getAltTextValue from 'forms-utils-lib/utils/RichText/getAltTextValue';
import getImageSize from 'forms-utils-lib/utils/RichText/getImageSize';
import getSrcValue from 'forms-utils-lib/utils/RichText/getSrcValue';
import getImageAttr from 'forms-utils-lib/utils/RichText/getImageAttr';
import { getRichText } from 'FormsUI/selectors/FormDefinition';
export const getCurrentRichTextImage = state => {
  const currentSelectedItem = getSelectedFormItemReference(state);
  return getRichText(state, currentSelectedItem);
};
export const getCurrentRichTextImageAsDomElement = state => {
  const {
    content
  } = getCurrentRichTextImage(state);
  const divEl = document.createElement('div');
  divEl.innerHTML = content;
  return divEl.firstChild;
};
export const getAltText = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getAltTextValue(currentImageAsDomElement);
};
export const getSrc = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getSrcValue(currentImageAsDomElement, defaultImage);
};
export const getAlignment = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getAlignmentValue(currentImageAsDomElement, ALIGNMENT_OPTIONS);
};
export const getDataImgWidth = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getImageAttr(currentImageAsDomElement, 'data-img-width');
};
export const getWidth = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const fileWidth = getImageSize(currentImageAsDomElement, 'width');
  const imageWidth = getDataImgWidth(state);
  return imageWidth || fileWidth;
};
export const getHeight = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  const imageHeight = getImageAttr(currentImageAsDomElement, 'data-img-height');
  const fileHeight = getImageSize(currentImageAsDomElement, 'height');
  return imageHeight || fileHeight;
};
export const getAspectRatio = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getImageAttr(currentImageAsDomElement, 'data-img-aspect-ratio');
};
export const getIsMaxWidth = state => {
  const currentImageAsDomElement = getCurrentRichTextImageAsDomElement(state);
  return getImageAttr(currentImageAsDomElement, 'width') === '100%';
};